"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const AzureResourceNodeValidation_1 = require("../validations/AzureResourceNodeValidation");
const utils_1 = require("../helper/utils");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class AzureResourceNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.Azure_Resource };
    if (props.type !== types_1.NODE_TYPES.Azure_Resource)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        service: "",
        module: "",
        method: "",
        params: {},
        addOns: [],
        providers: []
      };
    return nodeData;
  }
  serialize(uiData) {
    return {
      ...uiData
    };
  }
  validate() {
    return new AzureResourceNodeValidation_1.AzureResourceNodeValidation().validate(
      this
    );
  }
  getResourcesForSelectedAddOns() {
    let resources = [];
    let data = this.getNodeData();
    if (!data) return [];
    let { addOns } = data;
    for (let addOn of addOns) {
      let { method, service } = addOn;
      const addOnPrettyName = service + "-" + method;
      let addOnLabel = [
        this.getNodeName(),
        utils_1.wordify(data.service),
        "addOns",
        addOnPrettyName
      ]
        .join(".")
        .replace(" ", "");
      resources.push({
        nodeRef: this,
        label: addOnLabel,
        selectedResourceId: this.id,
        path: ["addOns", addOnPrettyName, "data"].join("."),
        context: {
          outputPath: `addOns.${addOnPrettyName}.data`
        }
      });
    }
    return resources;
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      let { module, service, method } = nodeData;
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: [this.getNodeName(), utils_1.wordify(service || "")].join("."),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources.concat(this.getResourcesForSelectedAddOns());
  }
  async getOutputKeys(params) {
    let nodeData = this.getNodeData();
    if (!nodeData || !nodeData.module || !nodeData.service || !nodeData.method)
      return [];
    let { module, service, method } = nodeData;
    let outputKeys = await fetchOutputKeys_1.fetchAzureOutputKeys(
      this.getDataResolver(),
      module,
      service,
      method
    );
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.AZURE;
  }
}
exports.AzureResourceNode = AzureResourceNode;
//# sourceMappingURL=AzureResourceNode.js.map
